import { computed,Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private _counter: WritableSignal<number> = signal(0);
  private _loading: Signal<boolean> = computed(() => this._counter() > 0);

  get loading(): boolean {
    return this._loading();
  }

  show(): void {
    this._counter.update(value => value + 1);
  }

  hidden(): void {
    this._counter.update(value => {
      let counter: number = value - 1;
      if(counter < 0) counter = 0;
      return counter;
    });
  }

}



